/** PURE_IMPORTS_START  PURE_IMPORTS_END */
"use strict";
/*@__PURE__*/ Object.defineProperty(exports, "__esModule", { value: true });
exports.errorObject = { e: {} };
